import { defineFetch } from 'resift';

const makeValidateMappings = defineFetch({
  displayName: 'add member fetch',
  make: (sourceId: string) => ({
    request: (proposedMappings: any[]) => async ({ http }: any) => {
      return http({
        method: 'POST',
        route: `/sources/${sourceId}/validate-mappings`,
        data: { proposedMappings },
      });
    },
  }),
});

export default makeValidateMappings;
